import { readVehicle } from '@theme/tt-vehicle-finder';
import { parseList, verdictFor } from '@theme/tt-fitment-verdict';

/**
 * The compact fitment badge on a product card.
 *
 * Renders nothing until a vehicle is saved, and nothing for the 'unknown'
 * verdict — a grid where every card carries a grey "fitment unknown" chip
 * teaches shoppers to ignore the chip, which is the opposite of the point.
 *
 * Server-rendered markup is deliberately empty: the verdict depends on
 * localStorage, and Shopify's full-page cache would otherwise serve one
 * shopper's vehicle to everyone.
 */
class FitBadge extends HTMLElement {
  connectedCallback() {
    const vehicle = readVehicle();
    if (!vehicle) return;

    const verdict = verdictFor(vehicle, {
      makes: parseList(this.dataset.makes),
      models: parseList(this.dataset.models),
      years: parseList(this.dataset.years),
    });

    if (verdict === 'unknown') return;

    const span = document.createElement('span');
    span.className = `tt-fitbadge tt-fitbadge--${verdict}`;
    // textContent, not innerHTML — the label passes through merchant data.
    span.textContent = verdict === 'yes' ? this.dataset.labelYes || '' : this.dataset.labelNo || '';
    this.replaceChildren(span);
  }
}

if (!customElements.get('tt-fit-badge')) {
  customElements.define('tt-fit-badge', FitBadge);
}
